module.exports = __webpack_public_path__ + "b9b11985a54768896856542b6f685fea.png";